import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconInfo = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		viewBox: "0 0 44 44",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [/* @__PURE__ */ _jsxs("g", {
			filter: `url(#${__svgrId}-filter0_ii_2796_1785)`,
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 44,
				height: 44,
				rx: 12,
				fill: "#CBDFF7"
			}), /* @__PURE__ */ _jsxs("g", {
				filter: `url(#${__svgrId}-filter1_d_2796_1785)`,
				children: [
					/* @__PURE__ */ _jsxs("mask", {
						id: `${__svgrId}-path-2-outside-1_2796_1785`,
						maskUnits: "userSpaceOnUse",
						x: 14.6664,
						y: 7.31894,
						width: 14.4819,
						height: 29.9355,
						fill: "black",
						children: [/* @__PURE__ */ _jsx("rect", {
							fill: "white",
							x: 14.6664,
							y: 7.31894,
							width: 14.4819,
							height: 29.9355
						}), /* @__PURE__ */ _jsx("path", { d: "M22.1252 19.7962C23.2256 19.8925 24.0396 20.8625 23.9433 21.9629L23.1589 30.9287C23.0626 32.029 22.0926 32.843 20.9922 32.7467C19.8918 32.6505 19.0778 31.6804 19.1741 30.58L19.9585 21.6143C20.0548 20.5139 21.0249 19.6999 22.1252 19.7962ZM22.8225 11.8267C23.9228 11.9229 24.7368 12.893 24.6405 13.9934C24.5443 15.0937 23.5742 15.9077 22.4738 15.8114C21.3735 15.7152 20.5595 14.7451 20.6558 13.6447C20.752 12.5444 21.7221 11.7304 22.8225 11.8267Z" })]
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M22.1252 19.7962C23.2256 19.8925 24.0396 20.8625 23.9433 21.9629L23.1589 30.9287C23.0626 32.029 22.0926 32.843 20.9922 32.7467C19.8918 32.6505 19.0778 31.6804 19.1741 30.58L19.9585 21.6143C20.0548 20.5139 21.0249 19.6999 22.1252 19.7962ZM22.8225 11.8267C23.9228 11.9229 24.7368 12.893 24.6405 13.9934C24.5443 15.0937 23.5742 15.9077 22.4738 15.8114C21.3735 15.7152 20.5595 14.7451 20.6558 13.6447C20.752 12.5444 21.7221 11.7304 22.8225 11.8267Z",
						fill: "#CBDFF7"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M23.9433 21.9629L27.43 22.268V22.268L23.9433 21.9629ZM23.1589 30.9287L19.6722 30.6236L23.1589 30.9287ZM19.1741 30.58L15.6874 30.275V30.275L19.1741 30.58ZM19.9585 21.6143L16.4718 21.3092L19.9585 21.6143ZM22.1252 19.7962L21.8202 23.2829C20.9949 23.2107 20.3844 22.4831 20.4566 21.6579L23.9433 21.9629L27.43 22.268C27.6947 19.242 25.4563 16.5743 22.4303 16.3095L22.1252 19.7962ZM23.9433 21.9629L20.4566 21.6579L19.6722 30.6236L23.1589 30.9287L26.6456 31.2337L27.43 22.268L23.9433 21.9629ZM23.1589 30.9287L19.6722 30.6236C19.7444 29.7983 20.472 29.1879 21.2972 29.2601L20.9922 32.7467L20.6872 36.2334C23.7132 36.4982 26.3808 34.2597 26.6456 31.2337L23.1589 30.9287ZM20.9922 32.7467L21.2972 29.2601C22.1225 29.3323 22.733 30.0598 22.6608 30.8851L19.1741 30.58L15.6874 30.275C15.4227 33.301 17.6611 35.9687 20.6872 36.2334L20.9922 32.7467ZM19.1741 30.58L22.6608 30.8851L23.4452 21.9193L19.9585 21.6143L16.4718 21.3092L15.6874 30.275L19.1741 30.58ZM19.9585 21.6143L23.4452 21.9193C23.373 22.7446 22.6455 23.3551 21.8202 23.2829L22.1252 19.7962L22.4303 16.3095C19.4043 16.0448 16.7366 18.2832 16.4718 21.3092L19.9585 21.6143ZM22.8225 11.8267L22.5174 15.3133C21.6921 15.2411 21.0817 14.5136 21.1539 13.6883L24.6405 13.9934L28.1272 14.2984C28.392 11.2724 26.1535 8.60472 23.1275 8.33997L22.8225 11.8267ZM24.6405 13.9934L21.1539 13.6883C21.2261 12.863 21.9536 12.2526 22.7789 12.3248L22.4738 15.8114L22.1688 19.2981C25.1948 19.5629 27.8625 17.3244 28.1272 14.2984L24.6405 13.9934ZM22.4738 15.8114L22.7789 12.3248C23.6042 12.397 24.2147 13.1245 24.1424 13.9498L20.6558 13.6447L17.1691 13.3397C16.9043 16.3657 19.1428 19.0334 22.1688 19.2981L22.4738 15.8114ZM20.6558 13.6447L24.1424 13.9498C24.0702 14.7751 23.3427 15.3855 22.5174 15.3133L22.8225 11.8267L23.1275 8.33997C20.1015 8.07523 17.4338 10.3137 17.1691 13.3397L20.6558 13.6447Z",
						fill: "white",
						mask: `url(#${__svgrId}-path-2-outside-1_2796_1785)`
					}),
					/* @__PURE__ */ _jsxs("mask", {
						id: `${__svgrId}-path-4-outside-2_2796_1785`,
						maskUnits: "userSpaceOnUse",
						x: 16.8331,
						y: 9.48564,
						width: 10.1485,
						height: 25.6021,
						fill: "black",
						children: [/* @__PURE__ */ _jsx("rect", {
							fill: "white",
							x: 16.8331,
							y: 9.48564,
							width: 10.1485,
							height: 25.6021
						}), /* @__PURE__ */ _jsx("path", {
							d: "M22.1252 19.7962C23.2256 19.8925 24.0396 20.8625 23.9433 21.9629L23.1589 30.9287C23.0626 32.029 22.0926 32.843 20.9922 32.7467C19.8918 32.6505 19.0778 31.6804 19.1741 30.58L19.9585 21.6143C20.0548 20.5139 21.0249 19.6999 22.1252 19.7962ZM22.8225 11.8267C23.9228 11.9229 24.7368 12.893 24.6405 13.9934C24.5443 15.0937 23.5742 15.9077 22.4738 15.8114C21.3735 15.7152 20.5595 14.7451 20.6558 13.6447C20.752 12.5444 21.7221 11.7304 22.8225 11.8267Z",
							fill: "#CBDFF7"
						})]
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M22.1252 19.7962C23.2256 19.8925 24.0396 20.8625 23.9433 21.9629L23.1589 30.9287C23.0626 32.029 22.0926 32.843 20.9922 32.7467C19.8918 32.6505 19.0778 31.6804 19.1741 30.58L19.9585 21.6143C20.0548 20.5139 21.0249 19.6999 22.1252 19.7962ZM22.8225 11.8267C23.9228 11.9229 24.7368 12.893 24.6405 13.9934C24.5443 15.0937 23.5742 15.9077 22.4738 15.8114C21.3735 15.7152 20.5595 14.7451 20.6558 13.6447C20.752 12.5444 21.7221 11.7304 22.8225 11.8267Z",
						fill: "#CBDFF7"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M23.9433 21.9629L25.4376 22.0936V22.0936L23.9433 21.9629ZM23.1589 30.9287L21.6646 30.7979L23.1589 30.9287ZM19.1741 30.58L17.6798 30.4493V30.4493L19.1741 30.58ZM19.9585 21.6143L18.4642 21.4836L19.9585 21.6143ZM22.1252 19.7962L21.9945 21.2905C22.2696 21.3146 22.4731 21.5571 22.449 21.8322L23.9433 21.9629L25.4376 22.0936C25.6061 20.168 24.1816 18.4704 22.256 18.3019L22.1252 19.7962ZM23.9433 21.9629L22.449 21.8322L21.6646 30.7979L23.1589 30.9287L24.6532 31.0594L25.4376 22.0936L23.9433 21.9629ZM23.1589 30.9287L21.6646 30.7979C21.6405 31.073 21.398 31.2765 21.1229 31.2525L20.9922 32.7467L20.8615 34.241C22.7871 34.4095 24.4847 32.985 24.6532 31.0594L23.1589 30.9287ZM20.9922 32.7467L21.1229 31.2525C20.8478 31.2284 20.6443 30.9859 20.6684 30.7108L19.1741 30.58L17.6798 30.4493C17.5114 32.375 18.9358 34.0726 20.8615 34.241L20.9922 32.7467ZM19.1741 30.58L20.6684 30.7108L21.4528 21.745L19.9585 21.6143L18.4642 21.4836L17.6798 30.4493L19.1741 30.58ZM19.9585 21.6143L21.4528 21.745C21.4769 21.4699 21.7194 21.2664 21.9945 21.2905L22.1252 19.7962L22.256 18.3019C20.3303 18.1334 18.6327 19.5579 18.4642 21.4836L19.9585 21.6143ZM22.8225 11.8267L22.6917 13.3209C22.9668 13.345 23.1703 13.5875 23.1463 13.8626L24.6405 13.9934L26.1348 14.1241C26.3033 12.1984 24.8788 10.5008 22.9532 10.3324L22.8225 11.8267ZM24.6405 13.9934L23.1463 13.8626C23.1222 14.1377 22.8797 14.3412 22.6046 14.3171L22.4738 15.8114L22.3431 17.3057C24.2688 17.4742 25.9664 16.0497 26.1348 14.1241L24.6405 13.9934ZM22.4738 15.8114L22.6046 14.3171C22.3295 14.2931 22.126 14.0506 22.1501 13.7755L20.6558 13.6447L19.1615 13.514C18.993 15.4396 20.4175 17.1373 22.3431 17.3057L22.4738 15.8114ZM20.6558 13.6447L22.1501 13.7755C22.1741 13.5004 22.4166 13.2969 22.6917 13.3209L22.8225 11.8267L22.9532 10.3324C21.0276 10.1639 19.3299 11.5884 19.1615 13.514L20.6558 13.6447Z",
						fill: "#657198",
						mask: `url(#${__svgrId}-path-4-outside-2_2796_1785)`
					})
				]
			})]
		}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: `${__svgrId}-filter0_ii_2796_1785`,
			x: 0,
			y: 0,
			width: 44,
			height: 44,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feMorphology", {
					radius: 1,
					operator: "erode",
					in: "SourceAlpha",
					result: "effect1_innerShadow_2796_1785"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "shape",
					result: "effect1_innerShadow_2796_1785"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: -1 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_innerShadow_2796_1785",
					result: "effect2_innerShadow_2796_1785"
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: `${__svgrId}-filter1_d_2796_1785`,
			x: 14.666,
			y: 8.31836,
			width: 14.4824,
			height: 30.9355,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.396078 0 0 0 0 0.443137 0 0 0 0 0.596078 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_2796_1785"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_2796_1785",
					result: "shape"
				})
			]
		})] })]
	});
};
export default SvgIconInfo;
